$(document).ready(function(){
  let productCountdownBars = document.querySelectorAll('.coming-soon__countdown');

  if (productCountdownBars) {
    [].forEach.call(productCountdownBars, function(productCountdownBar) {

      let hideProductCountdown = document.querySelector('.product_countdown__wrap-expired');
      let showProductCountdown = document.querySelector('.product_countdown__wrap-content');

      let countDownYear = productCountdownBar.dataset.countdownYear;
      let countDownMonth = productCountdownBar.dataset.countdownMonth;
      let countDownDate = productCountdownBar.dataset.countdownDate;
      let countDownHour = productCountdownBar.dataset.countdownHour;
      let countDownMinute = productCountdownBar.dataset.countdownMinute;
      let countDownExpired = productCountdownBar.dataset.countdownExpired;

      let countDownParts = (countDownYear+'-'+countDownMonth+'-'+countDownDate+'-'+countDownHour+'-'+countDownMinute).split('-');

      let countDownFullDate = new Date(countDownParts[0], countDownParts[1] - 1, countDownParts[2], countDownParts[3], countDownParts[4]).getTime();

      let x = setInterval(function() {

        let now = new Date().getTime();
        let distance = countDownFullDate - now;

        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        if (days < 10) {
          days = "0" + days;
        }
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        if (hours < 10) {
          hours = "0" + hours;
        }
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        if (seconds < 10) {
          seconds = "0" + seconds;
        }

        productCountdownBar.innerHTML = '<div class="coming-soon__countdown-item"><div>' + days + '</div><span>DAYS</span></div>' + '<div class="coming-soon__countdown-item"><div>' + hours + '</div><span>HOURS</span></div>' + '<div class="coming-soon__countdown-item"><div>' + minutes + '</div><span>MINUTES</span></div>' + '<div class="coming-soon__countdown-item"><div>' + seconds + '</div><span>SECONDS</span></div>';

        if (distance < 0) {
          clearInterval(x);
          hideProductCountdown.classList.add('show');
          showProductCountdown.classList.remove('show');
        } else {
          showProductCountdown.classList.add('show');
        }
      }, 1000);
      
    });
  }

});


const mainSlider = new Swiper('.simple_slider__wrap', {
  slidesPerView: 1,
  loop: true,
  allowTouchMove: true,
});

const navSlider = new Swiper('.simple_slider__wrap--nav', {
  slidesPerView: 5,
  centeredSlides: true,
  slideToClickedSlide: true,
  loop: false,
  spaceBetween: 10,
  thumbs: {
    swiper: mainSlider,
  },
});

new Swiper('.article-products-slider', {
  slidesPerView: 1,
  slidesPerGroup: 1,
  loop: true,
  speed: 450,
  loopAddBlankSlides: false,
  navigation: {
    enabled: false
  },
  breakpoints: {
    769: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      loopAddBlankSlides: false,
      navigation: {
        enabled: true,
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }
  }
});

new Swiper(".signup-slider", {
  slidesPerView: 1,
  loop: true,
  speed: 1000,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: 3000
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  }
});